<template>
  <div id="TableTitleRow">
    <v-row style="margin: 0">
      <template v-for="col in columnsOptions">
        <v-col
          class="title-table"
          :class="{ ['text-actions']: col.value === 'actions', 'dense-rows': dense & (col.value === 'actions') }"
          cols="12"
          md
          :key="col.text"
        >
          <div v-if="col.value == 'actions'" class="text-actions mr-5"></div>
          <div v-else-if="col.value == 'stops'">{{ col.text }} <slot name="stops"></slot></div>
          <div v-else-if="col.value == 'financialData'">
            <b class="mr-1">Financeiro</b>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-on="on" v-bind="attrs" size="15" style="cursor: pointer">mdi-help-circle-outline</v-icon>
              </template>
              <div class="d-flex flex-column">
                <span><v-icon dark> mdi-cash-check</v-icon> - Pago</span>
                <span><v-icon dark> mdi-cash-minus</v-icon> - Falta pagar</span>
                <span><v-icon dark> mdi-cash-multiple</v-icon> - Total a pagar</span>
              </div>
            </v-tooltip>
          </div>
          <div v-else-if="col.value == 'shipmentfinancialData'">
            <b class="mr-1">Financeiro</b>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-on="on" v-bind="attrs" size="15" style="cursor: pointer">mdi-help-circle-outline</v-icon>
              </template>
              <div class="d-flex flex-column">
                <span><v-icon dark> mdi-cash-fast</v-icon> - Adiantamento</span>
                <span><v-icon dark> mdi-truck-outline</v-icon> - Frete</span>
                <span><v-icon dark> mdi-cash</v-icon> - Total pago</span>
              </div>
            </v-tooltip>
          </div>
          <div v-else>
            <b>{{ col.text }}</b>
          </div>
        </v-col>
      </template>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'TableTitleRow',
  props: {
    columnsOptions: {
      default: () => [],
      type: Array
    },
    dense: {
      default: false,
      type: Boolean
    }
  }
};
</script>

<style scoped>
.text-actions {
  text-align: end;
}
.dense-rows {
  max-width: 70px;
  width: 100%;
}
@media only screen and (max-width: 1800px) {
  .dense-rows {
    max-width: 80px;
    width: 100%;
  }
}
@media only screen and (max-width: 1600px) {
  .dense-rows {
    max-width: 110px;
    width: 100%;
  }
}
</style>
